// extracted by mini-css-extract-plugin
export default {"wrapper":"Cart_wrapper__Czhox","buy":"Cart_buy__Y4jAa","price":"Cart_price__EAXv4"};